/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/imageFeatureSection.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";

export interface IImageFeatureSectionMethods extends IPluginMethodMap {
  getImageFeatureSectionProps(args: any): Promise<any>;
}

export class ImageFeatureSectionService implements IAgentPlugin {
  readonly methods: IImageFeatureSectionMethods;

  constructor() {
    this.methods = {
      getImageFeatureSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const storageSrv = StorageModule.getInstance();
    const localStorage = storageSrv?.get("theme", "local");
    const bandLogo = localStorage?.bandLogo;
    const bandName = localStorage?.bandName
    console.log(config);
    config.imageFeatureFeatures.forEach((feature: any) => {
      if (feature.title.toLowerCase() === bandName.toLowerCase()) {
        feature.icon = bandLogo;
      }
    });
    console.log(config);
    return { ...(config || {}) };
  }
}
